import { FC } from 'react';
import { GenericError } from './GenericError';

export const ErrorComponent: FC = () => {
  return <GenericError title="Hubo un inconveniente" description="Vuelva a intentarlo." />;
};
